import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { WarehouseItemResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post } from "./common";

export const warehouseItem = {
    record(warehouseId?: string) {
        return (data: typeof Requests.WarehouseItem.Record.Input) => {
            return post<typeof data, WarehouseItemResponseTypes.Record>(
                `/warehouse-item/record/${warehouseId ?? ""}`,
                data,
            );
        };
    },
    create(data: typeof Requests.WarehouseItem.Create.Input) {
        return post<typeof data>("/warehouse-item/create", data);
    },
    obtain(id: string) {
        return get<WarehouseItemResponseTypes.Obtain>(`/warehouse-item/obtain/${id}`);
    },
    picker(warehouseId: string, search: string | undefined) {
        let url;
        if (search === undefined) {
            url = `/warehouse-item/picker/${warehouseId}`;
        } else {
            url = `/warehouse-item/picker/${warehouseId}?search=${search}`;
        }

        return get<WarehouseItemResponseTypes.Picker>(url);
    },
    recordHistory(id: string) {
        return (data: typeof Requests.WarehouseItem.RecordHistory.Input) => {
            return post<typeof data, WarehouseItemResponseTypes.RecordHistory>(
                `/warehouse-item/record-history/${id}`,
                data,
            );
        };
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.WarehouseItem.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/warehouse-item/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
